import ssc from './ssc';
// import choose5 from './choose5';
import pk10 from './pk10';

export default (type, data, Vue) => {
  if (type == 'ssc' || type == 'choose5' || type == 'hpten') {
    return ssc(data);
  }
  // if (type == 'xyrb') {
  //   return xyrb(data);
  // }
  if (type == 'PK10' || type == 'nn') {
    return pk10(data);
  }
  // if (type == 'ks') {
  //   return ks(data);
  // }
};



// WEBPACK FOOTER //
// ./src/pages/Trend/Daxiaodanshuanglishi/columns/index.js